import apiClient from './client';

export interface ValidatePromocodeResponse {
  success: boolean;
  discountAmount: number;
  finalPrice: number;
  reason?: string;
  code?: string;
  discountType?: 'percent' | 'fixed';
}

export async function validatePromocode(
  code: string,
  subtotal: number,
  deliveryCost?: number
): Promise<ValidatePromocodeResponse> {
  const response = await apiClient.post<{ data: ValidatePromocodeResponse }>('/api/promocode/validate', {
    code: code.trim(),
    subtotal,
    deliveryCost: deliveryCost ?? 0,
  });
  return response.data.data;
}
